"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)(_mui.Typography)(() => ({
  display: 'block',
  maxWidth: _constants.maxTextWidth
}));